module.exports = __webpack_public_path__ + "img/物料照片示例.192c6034.png";